import styles from "@/styles/Slideshow.module.css";
import { Database } from "@/components/Database";

type SlideshowProps = {
  url: string;
  database: Database | null;
};

export default function Slideshow({ url, database }: SlideshowProps) {
  if (!database) {
    return (
      <div className={styles.slideshow}>
        <div className={styles.slideshowSlider}>
          <div className={styles.placeholder}></div>
        </div>
      </div>
    );
  }

  const amountOfCastles = database.castles.filter((castle) => castle.rent).length;
  const slidePadding = 15;
  const imageWidth = 100;
  const totalSlideWidth = imageWidth + 2 * slidePadding;
  const sliderWidth = totalSlideWidth * (amountOfCastles * 2);
  const scrollTransform = totalSlideWidth * -1 * amountOfCastles;

  function redirect() {
    if (url.includes("verhuur") || url.includes("location")) {
      return "#";
    } else {
      if (url.includes("nl")) {
        return "/nl/verhuur#";
      } else if (url.includes("fr")) {
        return "/fr/location#";
      }
    }
  }

  function htmlSlides(key: string) {
    return database?.castles.map((castle) => {
    if (castle?.rent) {
      return (
        <a
          className={styles.slide}
          key={castle.imagePath + key}
          href={redirect() + castle.nameNL}
          style={{ padding: `${slidePadding}px` }}
        >
          {castle.imagePath ? (
            <img src={castle.imagePath} alt="Bouncy castle picture" width={100} height={100} />
          ) : (
            <div style={{ width: "100px", height: "100px" }}></div>
          )}
        </a>
      );
    }
  })
  }

  const slidesHTML = htmlSlides("1");
  const secondSlidesHTML = htmlSlides("2");

  return (
    <div className={styles.slideshow}>
      <div
        className={styles.slideshowSlider}
        style={
          {
            width: `${sliderWidth}px`,
            "--sliderWidth": `${scrollTransform}px`,
          } as React.CSSProperties
        }
      >
        {slidesHTML}
        {secondSlidesHTML}
      </div>
    </div>
  );
}
